import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    InputGroup,
    FormControl,
    Alert,
    Spinner,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import TemplateAgendamento from "./TemplateAgendamento";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { limpaTelefone } from "../utils/Funcoes";
import InputMask from 'react-input-mask';
import { WebsiteAgendamentoService } from "../services/api/WebsiteAgendamento/WebsiteAgendamentoService";
import md5 from 'blueimp-md5'
import { useCookies } from "react-cookie";

const LoginAgendamento = () => {


    const navigate = useNavigate()
    const { dominio } = useParams();
    const [isLogin, setIsLogin] = useState(true);
    const location = useLocation()
    const dadosAgendamento = location.state?.dadosAgendamento

    const HASH_COOKIE = md5(dominio)

    const [showPassword, setShowPassword] = useState(false);
    const [remember, setRemember] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [cookies, setCookie, removeCookie] = useCookies([HASH_COOKIE], { doNotParse: true });
    const empresaId = localStorage.getItem("company")

    const [cliente, setCliente] = useState({
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirmPassword: ''
    })
    console.log(dadosAgendamento)



    const validateEmail = (value) => {
        // simples validação
        return /\S+@\S+\.\S+/.test(value);
    };


    const handleSingIn = () => {
        navigate('/' + dominio + '/sign_in ', { state: { dadosAgendamento } })
    }


    const handleChange = (e) => {

        console.log(e.target.name)
        switch (e.target.name) {
            case 'nome':
                setCliente({
                    ...cliente,
                    nome: e.target.value
                })
                break;
            case 'sobrenome':
                setCliente({
                    ...cliente,
                    sobrenome: e.target.value
                })
                break;
            case 'email':
                setCliente({
                    ...cliente,
                    email: e.target.value
                })
                break;
            case 'password':
                setCliente({
                    ...cliente,
                    password: e.target.value
                })
                break;
            case 'confirmPassword':
                setCliente({
                    ...cliente,
                    confirmPassword: e.target.value
                })
                break;
            case 'celular':
                setCliente({
                    ...cliente,
                    celular: e.target.value
                })
                break;
        }

    }

    const onSubmit = async (data) => {

        console.log(cliente)
        console.log(isLogin)
        setError('')
        if (!isLogin) {
            if (cliente?.nome == '') {
                setError('Informe o seu nome!')
                return false;
            }
            if (cliente?.sobrenome == '') {
                setError('Informe o seu sobrenome!')
                return false;
            }
            if (cliente?.celular != '') {
                if (limpaTelefone(cliente?.celular).length != 11) {
                    setError("Número de celular inválido, por favor digite o número com o DDD");
                    return false;
                }
            }

            if (cliente?.email == '') {
                setError('Informe o email')
                return false;
            }
            if (!validateEmail(cliente?.email)) {
                setError('Por favor insira um e-mail válido.')
                return false;
            }
            if (cliente?.password.length < 6) {
                setError("A senha deve ter ao menos 6 caracteres.");
                return false;
            }
            if (cliente?.confirmPassword == '') {
                setError("Por favor confirme sua senha");
                return false;
            }

            if (cliente?.password != cliente?.confirmPassword) {
                setError("As senhas não sao iguais!");
                return false;
            }

            

            let dados = cliente;
            dados.empresasId = empresaId

           dados.celular = (dados?.celular !="") ? limpaTelefone(dados?.celular) : null;

            const result = await WebsiteAgendamentoService.registrarCliente(dados)
          
            if (result.status == "success") {

                ///fazer o login do cliente com um cookie
                let dataExp = new Date().getTime();
                dataExp = dataExp + 3600000
                dataExp = new Date(dataExp)
                console.log(dadosAgendamento)
                setCookie(HASH_COOKIE, result.data, { expires: dataExp })

                if (dadosAgendamento != undefined) {




                    const resultAgenda = await WebsiteAgendamentoService.storeAgendamento(empresaId, dadosAgendamento)
                    if (resultAgenda.success) {
                        console.log(resultAgenda)
                    }

                   navigate('/' + dominio )

                } else {
                    navigate('/' + dominio)
                }


                //verifica se exuste dados para agendamento e chama a api  para agendar e confirma caso tenha sucesso
            } else {

            }


        } else {
            if (cliente?.email == '') {
                setError('Informe o email')
                return false;
            }
            if (!validateEmail(cliente?.email)) {
                setError('Por favor insira um e-mail válido.')
                return false;
            }
            if (cliente?.password.length < 6) {
                setError("A senha deve ter ao menos 6 caracteres.");
                return false;
            }

            console.log('asdas')
            const result = await WebsiteAgendamentoService.loginCliente(empresaId, cliente)
            if (result == undefined) {
                setError('E-mail e/ou senha inválidos')
            } else {

                console.log(result)
                if (result?.status == 'success') {
                    localStorage.setItem('tkc_hsp', result.authorization.token)
                    localStorage.setItem('usc_hsp', JSON.stringify(result.user))

                    let dataExp = new Date().getTime();
                    dataExp = dataExp + 3600000
                    dataExp = new Date(dataExp)
                    console.log(dataExp)
                    setCookie(HASH_COOKIE, result, { expires: dataExp })

                    console.log(dadosAgendamento)
                    if (dadosAgendamento != undefined) {
                        let dadosAg = {
                            empresaId: empresaId,
                            data: dadosAgendamento.data,
                            horario: dadosAgendamento.horario.hora,
                            profissionalId: dadosAgendamento.profissional.id,
                            servicosId: dadosAgendamento.servico.id
                        }


                        const resultAgenda = await WebsiteAgendamentoService.storeAgendamento(dadosAg)
                        console.log(resultAgenda)
                        if (resultAgenda.success) {
                            console.log(resultAgenda)
                            navigate('/' + dominio + '/confirmAgendamento', { state: { dadosAgendamento } })
                        }
                    } else {
                        navigate('/' + dominio)
                    }



                }
            }

            console.log(result)
        }



    };

    useEffect(() => {
        console.log(location.pathname)
        if (location.pathname == "/" + dominio + '/sign_in') {
            setIsLogin(false)
        }
    }, [])

    console.log(md5('tese'))
    console.log(isLogin)
    console.log(cliente)
    return (
        <TemplateAgendamento>



            <Container className=" d-flex justify-content-center bg-light mt-15" style={{ padding: 0 }}>
                <Row className="w-100 justify-content-center">
                    <Col xs={11} sm={8} md={6} lg={4} style={{ padding: 0 }}>
                        <Card className="shadow-sm">
                            <Card.Body>


                                <h3 className="mb-3 text-center text-primary">
                                    {(isLogin) ? 'Entrar' : 'Crie sua conta'}
                                </h3>
                                {dadosAgendamento != 'undefined' && (
                                    <div className="alert alert-warning">Antes de confirmar o agendamento faça o login ou cadastre-se!</div>
                                )}


                                <Form >

                                    {!isLogin && <Form.Group className="mb-3" controlId="formNome">
                                        <Form.Label>Nome<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nome"
                                            name="nome"
                                            onChange={(e) => handleChange(e)}
                                            value={cliente?.nome}

                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Informe seu nome
                                        </Form.Control.Feedback>
                                    </Form.Group>}
                                    {!isLogin && <Form.Group className="mb-3" controlId="formSobrenome">
                                        <Form.Label>Sobrenome<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Sobrenome"
                                            name="sobrenome"
                                            onChange={(e) => handleChange(e)}
                                            value={cliente?.sobrenome}
                                            required

                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Informe seu nome e sobrenome
                                        </Form.Control.Feedback>
                                    </Form.Group>}
                                    {!isLogin &&
                                        <Form.Group className="mb-3" controlId="formCelular">
                                            <Form.Label>Celular</Form.Label>
                                            <InputGroup>
                                                <InputMask
                                                    type="text"
                                                    placeholder="Celular com DDD"
                                                    name="celular"
                                                    onChange={(e) => handleChange(e)}
                                                    value={cliente?.celular}
                                                    aria-label="celular"
                                                    className="form-control"
                                                    mask="(99) 99999-9999"
                                                    maskChar="_"
                                                />
                                            </InputGroup>
                                        </Form.Group>}
                                    <Form.Group className="mb-3" controlId="formEmail">
                                        <Form.Label>E-mail<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="seu@exemplo.com"
                                            onChange={(e) => handleChange(e)}
                                            value={cliente?.email}
                                            required

                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Forneça um e-mail válido.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formPassword">
                                        <Form.Label>Senha<span className="text-danger">*</span></Form.Label>
                                        <InputGroup>
                                            <FormControl
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Sua senha"
                                                name="password"
                                                onChange={(e) => handleChange(e)}
                                                value={cliente?.password}
                                                required
                                                minLength={6}
                                                aria-label="senha"
                                                autocomplete="new-password"
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => setShowPassword((s) => !s)}
                                                tabIndex={-1}
                                            >
                                                {showPassword ? "Ocultar" : "Mostrar"}
                                            </Button>
                                        </InputGroup>
                                        <Form.Text className="text-muted">Mínimo 6 caracteres.</Form.Text>
                                    </Form.Group>
                                    {!isLogin &&
                                        <Form.Group className="mb-3" controlId="formConfirmPassword">
                                            <Form.Label>Confirme a senha<span className="text-danger">*</span></Form.Label>
                                            <InputGroup>
                                                <FormControl
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Sua senha"
                                                    name="confirmPassword"
                                                    onChange={(e) => handleChange(e)}
                                                    value={cliente?.confirmPassword}
                                                    required
                                                    minLength={6}
                                                    aria-label="senha"
                                                    autocomplete="new-password"
                                                />

                                            </InputGroup>

                                        </Form.Group>}

                                    { /**isLogin && <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                                        <Form.Check
                                            type="checkbox"
                                            label="Lembrar-me"
                                            checked={remember}
                                            onChange={(e) => setRemember(e.target.checked)}
                                        />
                                    </Form.Group>**/}
                                    {isLogin && <Form.Group className="mb-3 d-flex justify-content-between align-items-center">

                                        <a href="#" onClick={(e) => e.preventDefault()}>
                                            Esqueceu a senha?
                                        </a>
                                    </Form.Group>}


                                    {error && (
                                        <Alert variant="danger" onClose={() => setError("")} dismissible>
                                            {error}
                                        </Alert>
                                    )}


                                    <div className="d-grid mb-2">
                                        <Button variant="primary" disabled={loading} onClick={() => onSubmit()}>
                                            {loading ? (
                                                <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden />{' '}
                                                    Entrando...
                                                </>
                                            ) : (
                                                (isLogin) ? 'Entrar' : 'Criar conta'
                                            )}
                                        </Button>
                                    </div>
                                </Form>


                                { /*  <div className="text-center">
                                        <small className="text-muted">ou entre com</small>
                                    </div>

                                    <div className="d-flex gap-2 mt-2">
                                        <Button variant="outline-primary" className="w-100" onClick={() => alert('Login social: Google (exemplo)')}>
                                            Google
                                        </Button>
                                        <Button variant="outline-secondary" className="w-100" onClick={() => alert('Login social: Facebook (exemplo)')}>
                                            Facebook
                                        </Button>
                                        
                                </div>*/}

                                <hr />
                                {isLogin &&
                                    <div className="text-center">
                                        <span style={{ color: '#000' }}>Não tem conta? </span>
                                        <a href="" onClick={() => handleSingIn()} >Criar conta</a>
                                    </div>}

                            </Card.Body>
                        </Card>


                    </Col>
                </Row>
            </Container>
        </TemplateAgendamento >
    );
}

export default LoginAgendamento